export default __webpack_public_path__ + "static/bubble_annualreports-b1dd8860896e07653bc14b948ad51ad3.jpg";